import React, { FC } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { PATH_DASHBOARD, PATH_PROPERTIES } from 'routes/routesPaths';
import MenuItemContent from 'components/Menu/MenuItemContent';

const LogoMenu: FC = () => {
  const { pathname } = useLocation();
  const { formatMessage } = useIntl();

  return (
    <div>
      <MenuItem to={PATH_DASHBOARD} $active={pathname === PATH_DASHBOARD}>
        <MenuItemContent content={formatMessage({ id: 'navbar.dashboard' })} />
      </MenuItem>
      <MenuItem to={PATH_PROPERTIES} $active={pathname.includes(PATH_PROPERTIES)}>
        <MenuItemContent content={formatMessage({ id: 'navbar.properties' })} />
      </MenuItem>
    </div>
  );
};

const MenuItem = styled(Link)<{ $active: boolean }>`
  color: ${({ theme, $active }) => ($active ? theme.color.titleColor : theme.color.textColor)};
  font-weight: ${({ theme, $active }) => ($active ? theme.font.weight.medium : theme.font.weight.regular)};
  padding-right: ${({ theme }) => theme.paddings.medium};
`;

export default LogoMenu;
